import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';
import Polyline from '@mapbox/polyline';
import { Paper, RaisedButton, Tabs, Tab, AutoComplete, Dialog, Divider } from 'material-ui';
import { change, reset } from 'redux-form/immutable';
import FontAwesome from 'react-fontawesome';

import { GMapsC } from 'modules/general/component';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import { FORM_TRAYECTO, FORM_TRAYECTO_PARADA, FORM_TRAYECTO_FOTO } from 'modules/forms/formConstants';
import { TextFieldF, AutoCompleteF, CheckBoxFieldF } from 'modules/forms/component';
import * as validations from 'modules/forms/validations';
import CheckListParadas from './checkListParadas';

import * as trayectosActions from 'modules/trayectos/action';
import * as paradasActions from 'modules/paradas/action';
import * as generalActions from 'modules/general/action';
import { CancelarButtonC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';
import { filterByPolyline } from 'core/generalFunctions';

const selector = formValueSelector(FORM_TRAYECTO);
const maxPhotos = 10;

const DatosTab = (props) => {
  let paradas = props.paradas && props.paradas.toJS();
  return (
    <div className="p-lr-10">
      <Field
        name={'polyline'}
        component={TextFieldF}
        inputProps={{
          className: 'hidden',
        }}
        validate={validations.required}
      />
      <Field
        name={'nombre'}
        component={TextFieldF}
        inputProps={{
          hintText: 'Nombre',
          floatingLabelText: 'Ingrese el nombre',
          className: 'capitalize',
          fullWidth: true,
          autoFocus: true,
        }}
        validate={[validations.required, validations.minLength3]}
      />
      <Field
        name={'subnombre'}
        component={TextFieldF}
        inputProps={{
          fullWidth: true,
          className: 'capitalize',
          floatingLabelText: 'Recorrido/Ramal',
          hintText: 'Ingrese el recorrido/ramal:',
        }}
        validate={[validations.minLength3, validations.maxLength80]}
      />
      <Field
        name="paradaSubida"
        component={AutoCompleteF}
        inputProps={{
          openOnFocus: true,
          fullWidth: true,
          dataSource: paradas,
          floatingLabelText: 'Salida',
          dataSourceConfig: { text: 'alias', value: 'id' },
          filter: AutoComplete.caseInsensitiveFilter,
        }}
        onChange={(e, newId) => props.addPoint(newId)}
        onBlur={(e) => e.preventDefault()}
        validate={[validations.required, validations.noObject]}
      />
      <Field
        name="paradaBajada"
        component={AutoCompleteF}
        inputProps={{
          openOnFocus: true,
          fullWidth: true,
          dataSource: paradas,
          floatingLabelText: 'Destino',
          dataSourceConfig: { text: 'alias', value: 'id' },
          filter: AutoComplete.caseInsensitiveFilter,
        }}
        onChange={(e, newId) => props.addPoint(newId)}
        onBlur={(e) => e.preventDefault()}
        validate={[validations.required, validations.noObject]}
      />
      <Row>
        <Col md="12">
          <Field
            name="autoOrdenarParadas"
            inputProps={{
              className: 'mt-10',
              label: 'Optimizar orden de paradas',
            }}
            component={CheckBoxFieldF}
          />
        </Col>
      </Row>
      <RaisedButton onClick={props.genTrayecto} label="GENERAR TRAYECTO" primary={true} disabled={!props.paradaSubida || !props.paradaBajada} className="fullWidthComponent noPadding m-tb-20" />
      <RaisedButton secondary onClick={props.borrarTodo} label="BORRAR" className="fullWidthComponent noPadding" />
    </div>
  );
};

const ParadasTab = (props) => {
  return (
    <div>
      {props.mapLoad && <CheckListParadas paradasSelectMap={props.paradasSelectMap} setParada={props.addParada} change={props.change} trayectoPoly={props.points} shiftPress={props.shiftPress} />}
      <div className="pt-30 textCenter">
        <p>
          Presiona la tecla <b>Shift</b> y haz click en el mapa para crear paradas.
        </p>
      </div>
    </div>
  );
};

const FotosTab = (props) => {
  const { tasks, deleteTask } = props;
  const photosLimitReached = tasks && tasks.size >= maxPhotos;

  return (
    <div style={{ paddingTop: 20 }}>
      {tasks &&
        tasks.map((task) => {
          if (task.get('executeAtLocation'))
            return (
              <div key={task.get('id')}>
                <Row style={{ paddingTop: 10 }}>
                  <Col md="9" style={{ alignSelf: 'center' }}>
                    <p style={{ paddingLeft: 10 }}>{task.get('nombre')}</p>
                  </Col>
                  <Col md="2">
                    <RaisedButton secondary onClick={() => deleteTask(task.get('id'))} icon={<FontAwesome name="trash" className="white" />} className="fullWidthComponent noPadding" />
                  </Col>
                </Row>
                <Divider />
              </div>
            );
        })}
      <div className="pt-30 textCenter">
        {!photosLimitReached ? (
          <p>
            Presiona la tecla <b>Shift</b> y haz click en el mapa para programar una foto.
          </p>
        ) : (
          <p>
            <b>Se ha alcanzado el límite de {maxPhotos} fotos por trayecto.</b>
          </p>
        )}
      </div>
    </div>
  );
};

class Add extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paradasSelectMap: Map(),
      salidaDestino: [],
      points: null,
      mapLoad: false,
      ifFit: false,
      zoomLevel: null,
      resetState: false,
      changeParada: false,
      paradasCercanas: Map(),
      shiftPress: false,
      showNewParada: false,
      showNewPhotoTask: false,
      currentTab: 'datos',
    };
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }
  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    const {
      dispatch,
      params: { trayectoId },
    } = this.props;
    if (trayectoId == 'new') dispatch(generalActions.dashboard_changeTitle('NUEVO TRAYECTO'));
    else {
      dispatch(generalActions.dashboard_changeTitle('MODIFICAR TRAYECTO'));
      dispatch(trayectosActions.getFull(this.props.params.trayectoId));
      dispatch(trayectosActions.getTasks(this.props.params.trayectoId, 'takePhoto'));
    }
    window.document.onkeydown = (e) => {
      if (e.keyCode == '16' && !this.state.shiftPress) this.setState({ shiftPress: true });
    };
    window.document.onkeyup = (e) => {
      if (e.keyCode == '16') this.setState({ shiftPress: false });
    };
  }
  componentWillUnmount = () => {
    this.props.dispatch(trayectosActions.clear('all'));
    window.document.onkeydown = () => {};
    window.document.onkeyup = () => {};
  };
  actualizarParadas() {
    const { points, paradasSelectMap } = this.state;
    const { todasLasParadas, paradasRadio } = this.props;
    if (!points || !paradasSelectMap) return;

    let paradasCercanas = this.props.paradas.filter((p) => {
      if (!points) return true;
      if (!p.get('localizacion')) return false;

      return todasLasParadas
        ? !paradasSelectMap.find((pm, id) => p.get('id') == id)
        : filterByPolyline(points, p.getIn(['localizacion', 'lng']), p.getIn(['localizacion', 'lat']), paradasRadio) && !paradasSelectMap.find((pm, id) => p.get('id') == id);
    });
    this.setState({ paradasCercanas });
  }

  submitForm = (data) => {
    const { trayectoId } = this.props.params;
    if (!this.props.trayecto) return alert('Debe generar un trayecto.');
    let dataSend = formatData(data.toJS());

    dataSend.polyline = this.props.trayecto;
    dataSend.paradas = this.state.paradasSelectMap
      .map((parada) => parada && parada.get('id'))
      .keySeq()
      .toJS();

    this.props.dispatch(trayectosActions.set(dataSend, trayectoId == 'new' ? null : trayectoId));
  };
  addPoint = (paradaId) => {
    if (!paradaId) return;
    const { paradas } = this.props;
    let { paradasSelectMap } = this.state,
      datosParada = paradas.find((parada) => parada.get('id') == paradaId);
    if (datosParada) this.setState({ paradasSelectMap: paradasSelectMap.set(datosParada.get('id'), datosParada) });
  };
  genTrayecto = () => {
    const { paradaSubida, paradaBajada, paradas, autoOrdenarParadas, dispatch } = this.props;
    if (paradas && paradas.size === 0) return alert('No hay paradas para generar el trayecto');
    let { waypoints } = this.props,
      paradasWaypoint = [];
    waypoints
      .sortBy((a) => a[1])
      .map((value) => {
        if (value[1] == '') return;
        let parada = paradas.find((p) => p && p.get('id') == value[0]);
        if (parada) parada = parada.get('localizacion').toJS();
        return parada && paradasWaypoint.push(parada);
      });
    const paradaSubidaItm = paradas.find((parada) => parada.get('id') == paradaSubida);
    const paradaBajadaItm = paradas.find((parada) => parada.get('id') == paradaBajada);
    if (!paradaSubidaItm || !paradaBajadaItm) return alert('No se encuentra la parada de salida o destino.');
    dispatch(trayectosActions.preview(paradaSubidaItm.get('localizacion').toJS(), paradaBajadaItm.get('localizacion').toJS(), paradasWaypoint, autoOrdenarParadas));
  };
  componentDidUpdate = (prevProps, prevState) => {
    const { trayecto, paradasSeleccionadas, paradas, todasLasParadas, paradasRadio } = this.props,
      { points, isFit, paradasSelectMap } = this.state;
    if ((trayecto && trayecto != prevProps.trayecto) || (!points && trayecto)) {
      this.setState({ points: Polyline.decode(trayecto).map((point) => ({ lng: point[1], lat: point[0] })) });
    }
    if (paradas.size > 0 && !this.state.resetState && paradasSeleccionadas && paradasSeleccionadas.size > 0 && this.state.paradasSelectMap.size == 0) {
      let paradasSelectMap = Map();
      paradasSeleccionadas.map((parada) => {
        if (parada.get('_paradas')) {
          paradasSelectMap = paradasSelectMap.set(parada.get('paradaId'), parada.get('_paradas'));
          this.setState({ paradasSelectMap });
        }
      });
    }
    if (!isFit) this.fitCoor();
    if ((trayecto && trayecto != prevProps.trayecto) || (!points && trayecto)) {
      this.setState({ points: Polyline.decode(trayecto).map((point) => ({ lng: point[1], lat: point[0] })) }, () => {
        // Llama a actualizarParadas una vez que points haya sido actualizado
        this.actualizarParadas();
      });
    }
    if (!prevState.paradasSelectMap.equals(paradasSelectMap) || paradasRadio != prevProps.paradasRadio || prevProps.todasLasParadas != todasLasParadas || prevProps.paradas.size != paradas.size)
      this.actualizarParadas();
  };
  borrarTodo = () => {
    this.props.reset();
    this.setState({ points: null, salidaDestino: [], paradasSelectMap: Map() });
  };
  setMapRef = (map) => (this.mapRef = map);
  fitCoor = () => {
    const { paradaSubida, paradaBajada, paradas } = this.props;
    if (this.mapRef && (paradaSubida || paradaBajada)) {
      let bounds = new window.google.maps.LatLngBounds(),
        pSalida = paradas.find((parada) => parada.get('id') == paradaSubida),
        pDestino = paradas.find((parada) => parada.get('id') == paradaBajada);

      pSalida && bounds.extend(new window.google.maps.LatLng(pSalida.getIn(['localizacion', 'lat']), pSalida.getIn(['localizacion', 'lng'])));
      pDestino && bounds.extend(new window.google.maps.LatLng(pDestino.getIn(['localizacion', 'lat']), pDestino.getIn(['localizacion', 'lng'])));
      pSalida && pDestino && this.mapRef.fitBounds(bounds);
      pSalida && pDestino && this.setState({ isFit: true });
    }
  };
  addParada = (value, parada, stateComplete) => {
    let { paradasSelectMap } = this.state;
    if (stateComplete) return this.setState({ paradasSelectMap: stateComplete, resetState: stateComplete.size == 0 });
    parada &&
      this.setState({
        paradasSelectMap: value ? paradasSelectMap.set(parada.get('id'), parada) : paradasSelectMap.delete(parada.get('id')),
        changeParada: true,
      });
    this.mapRef && value && parada && parada.get('localizacion') && this.mapRef.panTo({ ...parada.get('localizacion').toJS() });
  };
  removeParada = (id) => {
    let { paradasSelectMap } = this.state;
    this.setState({ paradasSelectMap: paradasSelectMap.delete(id), changeParada: true });
  };
  addParadaClick = (parada) => {
    let { paradasSelectMap } = this.state;
    this.setState({ paradasSelectMap: paradasSelectMap.set(parada.get('id'), parada), changeParada: true });
  };
  addNewParada = (e) => {
    if (this.state.shiftPress) {
      if (this.state.currentTab === 'paradas') {
        this.setState({ showNewParada: true });
        if (e && e.latLng && e.latLng.lat && e.latLng.lng) {
          const lat = e.latLng.lat(),
            lng = e.latLng.lng();
          this.props.dispatch(change(FORM_TRAYECTO_PARADA, 'localizacion', { lat, lng }));
          this.props.dispatch(change(FORM_TRAYECTO_PARADA, 'nombre', ''));
          this.props.dispatch(generalActions.reverseGeocoding({ lat, lng }, FORM_TRAYECTO_PARADA, 'nombre'));
        }
      } else if (this.state.currentTab === 'fotos' && this.props.tasks.size < maxPhotos) {
        this.setState({ showNewPhotoTask: true });
        if (e && e.latLng && e.latLng.lat && e.latLng.lng) {
          const lat = e.latLng.lat(),
            lng = e.latLng.lng();
          this.props.dispatch(change(FORM_TRAYECTO_FOTO, 'executeAtLocation', { lat, lng }));
          this.props.dispatch(generalActions.reverseGeocoding({ lat, lng }, FORM_TRAYECTO_FOTO, 'nombre'));
        }
      }
    }
  };
  routerWillLeave() {
    if (((!this.props.pristine || this.state.changeParada) && !this.props.submitSucceeded) || (!this.props.submitSucceeded && this.state.changeParada))
      return 'El formulario tiene cambios,  ¿Está seguro de querer salir?';
  }
  deleteTask = (taskId) => this.props.dispatch(trayectosActions.taskPhoto({ removeId: taskId, trayectoId: this.props.params.trayectoId }));

  render() {
    const { invalid, pristine, paradasRadio, tasks, nombreTrayecto } = this.props,
      { points, mapLoad, zoomLevel, paradasSelectMap, changeParada, showNewParada, showNewPhotoTask, paradasCercanas } = this.state;
    return (
      <Container fluid={true}>
        <Row>
          <Col md="5">
            <Paper zDepth={2} className="padding">
              <Tabs onChange={(value) => this.setState({ currentTab: value })}>
                <Tab label="Datos" value="datos">
                  <DatosTab addPoint={this.addPoint} genTrayecto={this.genTrayecto} borrarTodo={this.borrarTodo} {...this.props} {...this.state} />
                </Tab>
                <Tab label="Paradas" value="paradas">
                  <ParadasTab addParada={this.addParada} shiftPress={this.state.shiftPress} {...this.props} {...this.state} />
                </Tab>
                <Tab label="Fotos" value="fotos">
                  <FotosTab {...this.props} deleteTask={this.deleteTask} />
                </Tab>
              </Tabs>
            </Paper>
          </Col>
          <Col md="7">
            <Paper zDepth={2} className="noPaddingCard">
              <Tabs>
                <Tab label={`Trayecto${nombreTrayecto ? `: ${nombreTrayecto}` : ''}`}>
                  <div style={{ height: '70vh' }}>
                    <GMapsC
                      onMapClick={this.addNewParada.bind(this)}
                      zoomLevel={zoomLevel}
                      paradasRadio={paradasRadio}
                      trayecto={points}
                      markerClick={this.state.currentTab !== 'fotos' ? (id) => this.removeParada(id) : null}
                      addParadaClick={this.state.currentTab !== 'fotos' ? (parada) => this.addParadaClick(parada) : null}
                      onIdle={() => !mapLoad && this.setState({ mapLoad: true })}
                      mapRef={(map) => this.setMapRef(map)}
                      multipleMarkers={this.state.currentTab !== 'fotos' ? paradasSelectMap : null}
                      paradasCercanas={this.state.currentTab !== 'fotos' ? paradasCercanas : null}
                      photosMarkers={this.state.currentTab === 'fotos' ? tasks : null}
                      mapElement={<div style={{ height: '100%' }} />}
                      containerElement={<div style={{ height: '100%' }} />}
                      zoomChange={() => {
                        const actualZoom = this.mapRef.getZoom();
                        mapLoad && zoomLevel != actualZoom && this.setState({ zoomLevel: actualZoom });
                      }}
                    />
                  </div>
                </Tab>
              </Tabs>
            </Paper>
          </Col>

          <Col md="12">
            <RaisedButton
              onClick={this.props.handleSubmit(this.submitForm)}
              label="GUARDAR"
              primary={true}
              disabled={(pristine && !changeParada) || !checkPermissions(['admin', 'administrador_trayectos']) || invalid}
              className="fullWidthComponent noPadding mt-10"
            />
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <CancelarButtonC />
          </Col>
        </Row>
        <div className="pt-30 textCenter">
          <p>El orden en las paradas define por donde pasara el trayecto, recuerda deshabilitar "Optimizar orden de paradas" si quieres que sigan un orden espesifico</p>
          <br />
          <p>En "Restricción horaria" puedes poner la cantidad de minutos previos a comenzar un viaje en los que se deshabilitara la parada, por si necesitas que reserven con anticipación </p>
          <br />
          <p>Solo las paradas seleccionadas se podran elegir para reservar</p>
          <br />
          <p>Si no encuentras una parada amplia el radio o selecciona para ver todas</p>
        </div>
        <AddParadaComponent
          showNewParada={showNewParada}
          cancelar={() => {
            this.props.dispatch(reset(FORM_TRAYECTO_PARADA));
            this.setState({ showNewParada: false, shiftPress: false });
          }}
          guardar={(data) => {
            this.props.dispatch(paradasActions.set(data.toJS(), 'new', true));
            this.props.dispatch(reset(FORM_TRAYECTO_PARADA));
            this.setState({ showNewParada: false, shiftPress: false });
          }}
        />

        <AddPhotoTaskComponent
          showNewPhotoTask={showNewPhotoTask}
          cancelar={() => {
            this.props.dispatch(reset(FORM_TRAYECTO_FOTO));
            this.setState({ showNewPhotoTask: false, shiftPress: false });
          }}
          guardar={(data) => {
            this.props.dispatch(trayectosActions.taskPhoto({ trayectoId: this.props.params.trayectoId, ...data.toJS() }));
            this.props.dispatch(reset(FORM_TRAYECTO_FOTO));
            this.setState({ showNewPhotoTask: false, shiftPress: false });
          }}
        />
      </Container>
    );
  }
}

let AddParadaComponent = (props) => (
  <Dialog
    title="Agregar nueva parada"
    actions={[
      <RaisedButton
        key={2}
        disabled={!checkPermissions(['admin', 'administrador_trayectos']) || props.invalid}
        label="Guardar"
        primary
        keyboardFocused={true}
        onTouchTap={props.handleSubmit(props.guardar)}
        fullWidth={true}
      />,
      <RaisedButton key={1} label="Cancelar" secondary onTouchTap={props.cancelar} fullWidth={true} className="pt-15" />,
    ]}
    modal={true}
    className="confirmationDialog"
    open={props.showNewParada}
    onRequestClose={props.cancelar}
  >
    <Field
      name={'alias'}
      component={TextFieldF}
      inputProps={{
        hintText: 'Alias',
        floatingLabelText: 'Ingrese el alias',
        className: 'capitalize',
        fullWidth: true,
        autoFocus: true,
      }}
      validate={[validations.required, validations.minLength3, validations.maxLength50]}
    />
    <Field
      name={'nombre'}
      component={TextFieldF}
      inputProps={{
        hintText: 'Nombre',
        disabled: true,
        className: 'capitalize',
        fullWidth: true,
        autoFocus: true,
      }}
      validate={[validations.required, validations.minLength3]}
    />
    <Field
      name={'localizacion'}
      component={TextFieldF}
      inputProps={{
        disabled: true,
        className: 'hidden',
        fullWidth: true,
      }}
      validate={validations.required}
    />
  </Dialog>
);

AddParadaComponent = reduxForm({
  form: FORM_TRAYECTO_PARADA,
  enableReinitialize: true,
})(AddParadaComponent);

let AddPhotoTaskComponent = (props) => (
  <Dialog
    title="Agregar nueva tarea de foto"
    actions={[
      <RaisedButton
        key={2}
        disabled={!checkPermissions(['admin', 'administrador_trayectos']) || props.invalid}
        label="Guardar"
        primary
        keyboardFocused={true}
        onTouchTap={props.handleSubmit(props.guardar)}
        fullWidth={true}
      />,
      <RaisedButton key={1} label="Cancelar" secondary onTouchTap={props.cancelar} fullWidth={true} className="pt-15" />,
    ]}
    modal={true}
    className="confirmationDialog"
    open={props.showNewPhotoTask}
    onRequestClose={props.cancelar}
  >
    <Field
      name={'nombre'}
      component={TextFieldF}
      inputProps={{
        hintText: 'Nombre',
        floatingLabelText: 'Ingrese el nombre',
        className: 'capitalize',
        fullWidth: true,
        autoFocus: true,
      }}
      validate={[validations.required, validations.minLength3, validations.maxLength200]}
    />
    <Field
      name={'executeAtLocation'}
      component={TextFieldF}
      inputProps={{
        disabled: true,
        className: 'hidden',
        fullWidth: true,
      }}
      validate={validations.required}
    />
  </Dialog>
);

AddPhotoTaskComponent = reduxForm({
  form: FORM_TRAYECTO_FOTO,
  enableReinitialize: true,
})(AddPhotoTaskComponent);

const formatData = (data) => {
  let waypoints = [],
    dataClon = Object.assign({}, data);

  if (dataClon.waypoints) Object.keys(dataClon.waypoints).forEach((paradaId) => dataClon.waypoints[paradaId] != '' && waypoints.push({ paradaId, order: dataClon.waypoints[paradaId] }));
  dataClon.waypoints = waypoints;

  delete dataClon._trayectoParadas;
  delete dataClon.autoOrdenarParadas;
  delete dataClon.todasLasParadas;

  return dataClon;
};

Add = reduxForm({
  form: FORM_TRAYECTO,
  enableReinitialize: true,
})(Add);

Add = connect((store) => {
  let waypointSelec = Map(),
    restriccionHorariaSelec = Map(),
    waypoints = store.getIn(['trayectos', 'trayecto', 'waypoints']),
    trayectoParadas = store.getIn(['trayectos', 'trayecto', '_trayectoParadas']);

  if (waypoints)
    waypoints.map((waypoint) => {
      if (waypoint.get('order')) waypointSelec = waypointSelec.set(waypoint.get('paradaId'), waypoint.get('order'));
    });
  if (trayectoParadas)
    trayectoParadas.map((trayectoParada) => {
      if (trayectoParada.get('restriccionHoraria')) restriccionHorariaSelec = restriccionHorariaSelec.set(trayectoParada.get('paradaId'), trayectoParada.get('restriccionHoraria'));
    });

  return {
    trayecto: selector(store, 'polyline'),
    paradas: store.getIn(['paradas', 'lista']),
    paradaSubida: selector(store, 'paradaSubida'),
    paradaBajada: selector(store, 'paradaBajada'),
    autoOrdenarParadas: selector(store, 'autoOrdenarParadas'),
    paradasSeleccionadas: store.getIn(['trayectos', 'trayecto', '_trayectoParadas']),
    waypoints: List(selector(store, 'waypoints')),
    paradasRadio: selector(store, 'paradasRadio') || 50,
    todasLasParadas: selector(store, 'todasLasParadas'),
    restriccionHoraria: selector(store, 'restriccionHoraria'),
    tasks: store.getIn(['trayectos', 'tasks']),
    nombreTrayecto: selector(store, 'nombre'),
    initialValues: {
      nombre: store.getIn(['trayectos', 'trayecto', 'nombre']),
      subnombre: store.getIn(['trayectos', 'trayecto', 'subnombre']),
      paradaSubida: store.getIn(['trayectos', 'trayecto', 'paradaSubida']),
      paradaBajada: store.getIn(['trayectos', 'trayecto', 'paradaBajada']),
      polyline: store.getIn(['trayectos', 'trayecto', 'polyline']),
      paradasRadio: store.getIn(['trayectos', 'trayecto', 'paradasRadio']) || 50,
      waypoints: waypointSelec,
      restriccionHoraria: restriccionHorariaSelec,
      autoOrdenarParadas: true,
    },
  };
})(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/trayectos/components/add.js